<template>
  <SoPage>
    <SoSimpleTable
      :headers="['Email', 'Phone', 'Mobile', 'Account Number']"
      :items="[
        [
          freshdeskContact.data.raw_data.email || '-',
          freshdeskContact.data.raw_data.phone || '-',
          freshdeskContact.data.raw_data.mobile || '-',
          freshdeskContact.data.account_number || '-',
        ],
      ]"
      is-pivoted
      outlined
      equal-width-columns
      class="w-50"
    />
    <div class="d-flex align-center gap-2 my-4">
      <SoButton
        title="Freshdesk Contacts"
        type="secondary"
        prepend-icon="chevron-left"
        @click="goToFreshdeskContacts()"
      />
    </div>
    <SoWidget no-padding no-border plain>
      <ActivityFeed
        ref="feed"
        :feed-item-list="ticketsFeed.data"
        :is-loading="ticketsFeed.isFetching"
        height="calc(100vh - 320px)"
      />
    </SoWidget>
  </SoPage>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPage from "@/components/templates/SoPage.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import ActivityFeed from "@/views/customer/timeline/activityFeed/ActivityFeed.vue"
  import { RouteNames } from "@/types/router"
  import { getFreshdeskFeed } from "@/services-handlers/getFreshdeskFeed"
  import { FreshdeskService } from "@/services/FreshdeskService"

  export default defineComponent({
    components: {
      SoPage,
      SoWidget,
      SoButton,
      SoSimpleTable,
      ActivityFeed,
    },
    computed: {
      contactId() {
        const rawContactId = this.$route.params.contactId
        return Array.isArray(rawContactId) ? rawContactId[0] : rawContactId
      },
      freshdeskContact() {
        return FreshdeskService.getLegacyContact(Number(this.contactId))
      },
      ticketsFeed() {
        return getFreshdeskFeed(this.contactId)
      },
    },
    methods: {
      goToFreshdeskContacts() {
        this.$router.push({
          name: RouteNames.AdminFreshdeskContacts,
        })
      },
    },
  })
</script>
